<template>
	<el-row class="points-show">
		<el-col :span="23">
			标签管理
		</el-col>
		<el-divider></el-divider>
		<div>
			<el-col :span="24">
				<el-button size="mini" @click="crateLabel({ dicId: -1 })">
					增加枝干标签
				</el-button>
			</el-col>
			<el-col :span="24">
				<el-table :data="tableData" row-key="dicId" lazy ref="tableDom" :load="load"
					:tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
					<el-table-column prop="dicId" label="标签ID" width="180"> </el-table-column>
					<el-table-column prop="dicDesc" label="标签名称" width="180"> </el-table-column>
					<el-table-column prop="dicImage" label="封面图" width="180">
						<template slot-scope="scope" v-if="scope.row.dicImage">
							<el-image :src="scope.row.dicImage" style="width: 80px; height: 40px" fit="cover"
								:preview-src-list="scope.row.dicImage.split(',')" />
						</template>
					</el-table-column>
					<el-table-column prop="dicInfo" label="标签简介" width="180"> </el-table-column>
					<el-table-column prop="dicMatValue" label="应用模块" width="180"> </el-table-column>
					<el-table-column prop="status" label="是否展示" width="180">
						<template slot-scope="scope">
							<el-switch :disabled="scope.row.parentId != -1" style="display: block"
								v-model="scope.row.status == 0" active-color="#13ce66" inactive-color="#ff4949"
								active-text="展示" inactive-text="隐藏"
								@change="cantShow(scope.row.dicDesc, scope.row.dicId, scope.row.status)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="dicId" label="操作">
						<template slot-scope="scope">
							<el-button size="mini" :disabled="scope.row.parentId != -1" @click="crateLabel(scope.row)">
								增加叶子标签
							</el-button>

							<el-button size="mini" @click="resetLabel(scope.row)">
								编辑标签名称
							</el-button>
							<el-button size="mini" type="danger" :disabled="scope.row.hasChildren"
								@click="deleteDic(scope.row)">
								移除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
			<!-- 新建文件夹 -->
			<el-col :span="24">
				<el-dialog title="增加/编辑 标签" :visible.sync="dialogVisible" width="30%" :before-close="openOrCloseMode">
					<el-form ref="selectCurrRow" :model="selectCurrRow" label-width="70px">
						<el-form-item label="标签名称">
							<el-input v-model="selectCurrRow.dicDesc" placeholder="请输入标签名称" size="mini"></el-input>
						</el-form-item>
						<el-form-item label="封面图片">
							<!-- <el-radio-group v-model="radioValue" @input="chooseRadio">
								<el-radio label="0">本地上传</el-radio>
								<el-radio label="1">图片库上传</el-radio>
							</el-radio-group> -->
							<el-button @click="chooseRadio(1)" type="primary" size="mini" style="margin-bottom: 10px;">
								图片库上传
							</el-button>
							<el-upload class="hide" :action="uploadUrl" list-type="picture-card" :limit="1"
								accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="selectCurrRow.dicImageList"
								:on-success="handleChapterFormImage" :on-error="handleError" :multiple="true"
								:on-exceed="handleOverImage">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="标签简介">
							<el-input v-model="selectCurrRow.dicInfo" placeholder="请输入标签简介" size="mini"></el-input>
						</el-form-item>
						<el-form-item label="应用模块">
							<el-input v-model="selectCurrRow.dicMatValue" placeholder="请输入标签简介" size="mini"></el-input>
						</el-form-item>
						<el-form-item label="模块说明">
							<div>指标签应用在哪个方面，人为定义一个场景。在开发时固定这个场景。</div>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="openOrCloseMode">取 消</el-button>
						<el-button type="primary" @click="addFloter()">确 定</el-button>
					</span>
				</el-dialog>
			</el-col>
		</div>
		<el-drawer title="图片选择" :visible.sync="drawer" direction="rtl" size="40%">
			<SelectPicture :imgNum="1" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>
<script>
	import httpClient from '../../../util/request.js';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			SelectPicture
		},
		data() {
			return {
				radioValue: "0",
				drawer: false,
				// uploadUrl: 'https://pro.xinian727.com/api/product/common/uploadPicture',
				uploadUrl: httpClient.imgUrl,
				chapterImageFile: [],
				tableData: [],
				selectCurrRow: {
					dicDesc: "",
					dicId: null,
					dicImage: "",
					dicImageList: [],
					dicInfo: "",
					dicMatValue: "",
					dicType: 0,
					dicValue: -1,
					parentId: -1,
					status: 0,
				},
				// 当前操作的上级ID
				addParamPid: {},

				dialogVisible: false,
				floterName: '',
				loadMap: new Map(),
				labelType: ''
			}
		},
		created() {
			this.getData(-1);
		},
		methods: {
			chooseRadio() {
				this.drawer = true
			},
			getImg(e) {
				console.log(e)
				this.selectCurrRow.dicImage = e
				this.selectCurrRow.dicImageList = []
				e.split(',').forEach(item => {
					this.selectCurrRow.dicImageList.push({
						url: item
					})
				})
				this.drawer = false
			},
			cantShow(dicDesc, dicId, status) {
				status = status == 0 ? 1 : 0;
				this.$http.post('/api/source/matDic/update', {
					dicId: dicId,
					status: status
				}).then(res => {
					if (res.data.status == 0) {
						var statusText = status != 0 ? '隐藏' : '展示';
						if (status != 0) {
							this.$message.error(dicDesc + "已" + statusText);
						} else {
							this.$message.success(dicDesc + "已" + statusText);
						}
						this.getData(-1);
					} else {
						this.$message.error("发生未可知错误，请联系开发人员");
					}
				});
			},
			load(tree, treeNode, resolve) {
				var pid = tree.dicId;
				this.loadMap.set(pid, {
					tree,
					treeNode,
					resolve
				});
				this.getData(tree.dicId).then((res) => {
					if (res.length == 0) {
						// 没有下级
						tree.hasChildren = false;
					}
					resolve(res);
				})
			},
			getData(pid) {
				let promise = new Promise((resolve, reject) => {
					var _this = this;
					let url = '/api/source/matDic/selectByParentId?pid=' + pid;
					this.$http.get(url, {}).then(res => {
						if (res.data.status == 0) {
							var dataList = res.data.data;
							dataList.forEach(element => {
								element.dicImageList = [];
								if (element.dicImage) {
									element.dicImageList = [{
										url: element.dicImage
									}];
								}
								element.pid = pid;
								element.hasChildren = (pid == -1);
							});
							if (pid == -1) {
								this.tableData = dataList;
							} else {
								resolve(dataList);
							}
						} else {
							this.$message.error("查询失败");
						}
					});
				})
				return promise;
			},
			crateLabel(row) {
				this.resetForm();
				this.addParamPid = row;
				// resetFrom
				this.labelType = 'add';
				this.openOrCloseMode('add');
			},
			resetLabel(row) {
				this.resetForm();
				this.selectCurrRow = row;
				this.labelType = 'reset';
				this.openOrCloseMode('reset');
			},
			//文件夹操作 弹框
			openOrCloseMode(type) {
				if (type == 'add') {
					this.floterName = '';
				}
				this.dialogVisible = !this.dialogVisible;
			},
			addFloter() {
				if (this.selectCurrRow.floterName == '') {
					this.$message.warning("请输入标签名称");
					return;
				}
				if (this.labelType == 'add') {
					var _this = this;
					let url = '/api/source/matDic/add';
					let param = this.selectCurrRow;
					param.dicValue = this.addParamPid.dicId;
					param.parentId = this.addParamPid.dicId;
					this.$http.post(url, param).then(res => {
						if (res.data.status == 0) {
							this.$message.success("增加成功");
							if (this.addParamPid.dicId == -1) {
								// -1 说明增加父级标签
								this.getData(-1);
								this.openOrCloseMode();
							} else {
								this.openOrCloseMode();
								const {
									tree,
									treeNode,
									resolve
								} = this.loadMap.get(this.addParamPid.dicId);
								if (undefined != tree) {
									this.load(tree, treeNode, resolve);
								}
							}
						} else {
							this.$message.error("增加失败");
						}
					});
				}
				if (this.labelType == 'reset') {
					var _this = this;
					let url = '/api/source/matDic/update';
					this.$http.post(url, this.selectCurrRow).then(res => {
						if (res.data.status == 0) {
							this.$message.success("修改成功");
							if (this.selectCurrRow.parentId == -1) {
								// -1 说明增加父级标签
								this.getData(-1);
								this.openOrCloseMode();
							} else {
								const {
									tree,
									treeNode,
									resolve
								} = this.loadMap.get(this.selectCurrRow.parentId);
								if (tree != undefined) {
									this.load(tree, treeNode, resolve);
								}
								this.openOrCloseMode();
							}
						} else {
							this.$message.error("修改失败");
						}
					});
				}
			},
			deleteDic(row) {
				this.$confirm('此操作将永久删除该标签,并且对应素材也将失去该标签属性,是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var _this = this;
					let url = '/api/source/matDic/deleteDic?id=' + row.dicId;
					this.$http.get(url, {}).then(res => {
						if (res.data.status == 0) {
							this.$message.success("移除成功");
							if (row.parentId == -1) {
								// -1 说明增加父级标签
								this.getData(-1);
							} else {
								const {
									tree,
									treeNode,
									resolve
								} = this.loadMap.get(row.parentId);
								if (tree != undefined) {
									this.load(tree, treeNode, resolve);
								}
							}
						} else {
							this.$message.error("移除失败");
						}
					});
				}).catch(() => {});
			},
			handleChapterFormImage(response, file, fileList) {
				this.selectCurrRow.dicImage = response.data;

			},
			handleError(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			},
			handleOverImage(files, fileList) {
				this.$message.error("已超出最大上传数量限制");
			},
			resetForm() {
				this.selectCurrRow = {
					dicDesc: "",
					dicId: null,
					dicImage: "",
					dicImageList: [],
					dicInfo: "",
					dicMatValue: "",
					dicType: 0,
					dicValue: -1,
					parentId: -1,
					status: 0,
				}
			},
		}
	};
</script>
<style scoped lang="less">
	.el-button {
		margin: 0 10px 0 10px;
	}

	/deep/.el-input {
		width: auto;
	}

	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>
